import React from 'react';
import { EffectFade, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import TeamCard02 from '../../components/TeamElements/TeamCard02';

const TeamContainer02 = () => {
    const TeamData = [
        {
            id: '1',
            img: 'images/team/r1.png',
            name: 'Stefán Ómar Stefánsson - M.S. Vélar og Stálsmíði ehf. Véla- og suðumaður',
            email: 'vel.stal@simnet.is',
            phone: '+3548644024',  
        },
        {
            id: '2',
            img: 'images/team/r2.png',
            name: 'Hans Kristján Scheving - HSK Rafverktaki slf. - Rafvirkjameistari',
            email: 'hans.scheving@gmail.com',
            phone: '+3548989333',  
        },
        {
            id: '3',
            img: 'images/team/r3.png',
            name: 'Magnús Ómar Pálsson - ICE-Maggi slf. Rafvirki',
            email: 'maggiop@gmail.com',
            phone: '+3548998668',  
        },
        {
            id: '4',
            img: 'images/team/r4.png',
            name: 'Reynir Jónasson - RJ-RAF ehf. - Rafvirki',
            email: 'reynir7@gmail.com',
            phone: '+3548956601',  
        },    {
            id: '5',
            img: 'images/team/r1.png',
            name: 'Stefán Ómar Stefánsson - M.S. Vélar og Stálsmíði ehf. Véla- og suðumaður',
            email: 'vel.stal@simnet.is',
            phone: '+3548644024',  
        },
        {
            id: '6',
            img: 'images/team/r2.png',
            name: 'Hans Kristján Scheving - HSK Rafverktaki slf. - Rafvirkjameistari',
            email: 'hans.scheving@gmail.com',
            phone: '+3548989333',  
        },
        {
            id: '7',
            img: 'images/team/r3.png',
            name: 'Magnús Ómar Pálsson - ICE-Maggi slf. Rafvirki',
            email: 'maggiop@gmail.com',
            phone: '+3548998668',  
        },
        {
            id: '8',
            img: 'images/team/r4.png',
            name: 'Reynir Jónasson - RJ-RAF ehf. - Rafvirki',
            email: 'reynir7@gmail.com',
            phone: '+3548956601',  
        },
     
    ]
    return (
        <section >
            <div className="container">
                <div className="section-header text-center has_line">
                    <h1 className="text-white">Samstarfsmenn</h1>
                </div>

                <div className="team_inner">
                    <div className="swiper swiper_team">
                        <Swiper
                            modules={[Navigation, EffectFade, Pagination]}
                            effect="slide"
                            breakpoints={{
                                600: {
                                    width: 600,
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                768: {
                                    width: 768,
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                                992: {
                                    width: 992,
                                    slidesPerView: 3,
                                    spaceBetween: 65,
                                },
                            }}
                            autoHeight={true}
                            parallax={true}
                            controller={{
                                inverse: true,
                            }}
                            slideToClickedSlide={true}
                            loop={true}
                            navigation={{
                                prevEl: '.swiper-button-prev',
                                nextEl: '.swiper-button-next',
                            }}
                        >
                            {
                                TeamData.map(data =>
                                    <SwiperSlide>
                                        <TeamCard02
                                            key={data.id}
                                            data={data}
                                        />
                                    </SwiperSlide>)
                            }
                        </Swiper>

                        {/* <!-- Add Buttons --> */}
                        <div className="swiper-navigation">
                            <div className="swiper-button-prev"><i className="bi bi-arrow-left"></i></div>
                            <div className="swiper-button-next"><i className="bi bi-arrow-right"></i></div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamContainer02;